// src/utils/emailService.js
// ──────────────────────────────────────────────────────────────────────────────
// CONFIGURACIÓN EmailJS (gratis hasta 200 emails/mes)
// 1. Regístrate en https://www.emailjs.com
// 2. Crea un "Email Service" conectando tu Gmail
// 3. Crea un "Email Template" con estas variables:
//      {{to_name}}  {{to_email}}  {{subject}}  {{message}}  {{from_name}}
// 4. Reemplaza los 3 valores de abajo con los tuyos:
// ──────────────────────────────────────────────────────────────────────────────
import emailjs from "@emailjs/browser";
import toast from "react-hot-toast";

const EMAILJS_SERVICE_ID  = "TU_SERVICE_ID";   // ← reemplaza
const EMAILJS_TEMPLATE_ID = "TU_TEMPLATE_ID";  // ← reemplaza
const EMAILJS_PUBLIC_KEY  = "TU_PUBLIC_KEY";   // ← reemplaza

/**
 * Envía un email automático via EmailJS.
 * @param {string} toEmail    - Email del destinatario
 * @param {string} toName     - Nombre del destinatario
 * @param {string} subject    - Asunto del email
 * @param {string} message    - Cuerpo del mensaje
 */
export async function enviarEmail(toEmail, toName, subject, message) {
  if (!toEmail) {
    toast.error("Este cliente no tiene email registrado.");
    return;
  }

  const templateParams = {
    to_name:   toName,
    to_email:  toEmail,
    subject:   subject,
    message:   message,
    from_name: "Mi CRM",
  };

  try {
    await emailjs.send(
      EMAILJS_SERVICE_ID,
      EMAILJS_TEMPLATE_ID,
      templateParams,
      EMAILJS_PUBLIC_KEY
    );
    toast.success(`✉️ Email enviado a ${toName}`);
  } catch (error) {
    console.error("Error enviando email:", error);
    toast.error("No se pudo enviar el email. Verifica la configuración de EmailJS.");
  }
}

/**
 * Abre WhatsApp Web con el número y mensaje pre-llenado.
 * @param {string} telefono   - Número peruano (sin código de país)
 * @param {string} mensaje    - Texto del mensaje
 */
export function enviarWhatsApp(telefono, mensaje) {
  if (!telefono) {
    toast.error("Este cliente no tiene teléfono registrado.");
    return;
  }
  // Limpia el número y agrega código Perú (+51)
  const numero  = telefono.replace(/\D/g, "");
  const prefijo = numero.startsWith("51") ? numero : `51${numero}`;
  const url = `https://wa.me/${prefijo}?text=${encodeURIComponent(mensaje)}`;
  window.open(url, "_blank");
}

// ──────────────────────────────────────────────────────────────────────────────
// PLANTILLAS DE MENSAJES PREDEFINIDOS
// Puedes usarlas en Seguimiento.jsx para envíos con 1 click
// ──────────────────────────────────────────────────────────────────────────────
export const PLANTILLAS = {
  seguimiento: (nombre) =>
    `Hola ${nombre?.split(" ")[0]}, te escribo para hacer seguimiento a tu consulta. ¿Pudiste revisar la propuesta que te envié? Quedo a tu disposición.`,

  propuesta: (nombre) =>
    `Hola ${nombre?.split(" ")[0]}, te comento que ya tenemos lista tu propuesta personalizada. ¿Cuándo tienes 15 minutos para revisarla juntos?`,

  recordatorio: (nombre) =>
    `Hola ${nombre?.split(" ")[0]}, te recuerdo que tenemos una reunión programada. Por favor confírmame si puedes asistir.`,

  cierre: (nombre) =>
    `Hola ${nombre?.split(" ")[0]}, quería saber si ya pudiste tomar una decisión sobre nuestra propuesta. Estoy disponible para resolver cualquier duda.`,

  bienvenida: (nombre) =>
    `Hola ${nombre?.split(" ")[0]}, un gusto conocerte. Te escribo para coordinar una llamada de 15 minutos y entender mejor cómo podemos ayudarte.`,
};
